// extracted by mini-css-extract-plugin
export default {"container":"HOoSj2t4jqN9W3eELnNo","label":"pJXBRC4EFICNjtAa1vLZ","description":"aw8eiZGbofW6Z1DDzMv0","termsContainer":"y8wgNb0JQPOncx6D6wwb","pulse":"pMQd92hd15NCEbfXABgl"};